import React from "react";
import { Avatar } from "@mui/material";

const AvatarCustom = ({ name, imageUrl, sx }) => {
  return <Avatar alt={name} src={imageUrl} sx={sx} />;
};

export default AvatarCustom;
